<template>
  <div
    slot="footer"
    class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
  >
    <div>
      <p class="card-category">
        {{ $t('table.showing') }} {{ froms }} {{ $t('table.to') }} {{ tos }}
        {{ $t('table.of') }} {{ totals }} {{ $t('table.entries') }}
      </p>
    </div>
    <l-pagination
      class="pagination-no-border"
      v-model="pagination.currentPage"
      :per-page="pagination.perPage"
      :total="pagination.total"
      pageFirst="false"
      pageLast="false"
    ></l-pagination>
  </div>
</template>

<script>
import { Pagination as LPagination } from 'src/components/index';
import Tables from 'src/class/Tables';

export default {
  name: 'card-footer',
  components: {
    LPagination,
  },
  props: {
    propPagination: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pagination: this.propPagination
        ? this.propPagination
        : Tables.Table.pagination,
      froms: 0,
      tos: 0,
      totals: 0,
    };
  },
  watch: {
    propPagination: {
      immediate: true, // Para ejecutar el watcher cuando el componente se monta
      deep: true, // Para detectar cambios internos en el objeto
      handler(newPagination) {
        this.updatePaginationValues(newPagination);
        this.pagination = newPagination; //fuerza actualizacion en caso de asidelist
      },
    },
  },
  methods: {
    updatePaginationValues(pagination) {
      if (pagination && pagination.total > 0) {
        this.froms = (pagination.currentPage - 1) * pagination.perPage + 1;
        this.tos = Math.min(
          pagination.currentPage * pagination.perPage,
          pagination.total
        );
        this.totals = pagination.total;
      } else {
        this.froms = 0;
        this.tos = 0;
        this.totals = 0;
      }
    },
  },
  mounted() {
    this.updatePaginationValues(this.propPagination);
  },
};
</script>
